import FooterSub from './FooterSub';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { withModel } from '../../../data-providers/model';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withModel,
  withProps(props => ({
    boringLinks: props.boringLinks.map(link => ({
      ...link,
      url: localiseUrl(props.model.countryModel, link.url)
    }))
  }))
);

export default enhance(FooterSub);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Footer/FooterSub/index.js